import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Panel } from '../ui/Panel';
import { cgpa, results } from '../../data/academics';
export function ResultsPanel() {
  const [openId, setOpenId] = useState<string>(results[0].id);
  return <div className="grid gap-6 lg:grid-cols-3" data-id="element-351" data-mp="2sehlwbqcvhp6">
      <div className="space-y-6 lg:col-span-2" data-id="element-352" data-mp="2xfx1ho9rkw06">
        {results.map(semester => {
        const open = semester.id === openId;
        return <Panel key={semester.id} bodyClassName="p-0" data-id="element-353" data-mp="1zq279qb4z1ed">
              <button type="button" onClick={() => setOpenId(open ? '' : semester.id)} aria-expanded={open} className="flex w-full items-center gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-canvas" data-id="element-354" data-mp="24rrkncltzr5m">
                <div className="min-w-0 flex-1" data-id="element-355" data-mp="1h0vv6m4ul81j">
                  <p className="text-[15px] font-semibold text-ink" data-id="element-356" data-mp="1m08it93jmj56">{semester.label}</p>
                  <p className="cz-num mt-0.5 text-[13px] text-ink-muted" data-id="element-357" data-mp="30q1ha8wwbi84">
                    {semester.units} units · {semester.grades.length} courses
                  </p>
                </div>
                <span className="cz-num text-lg font-semibold text-ink" data-id="element-358" data-mp="2r0879ccejb5z">
                  {semester.gpa.toFixed(2)}
                </span>
                <ChevronDownIcon className={`h-4 w-4 shrink-0 text-ink-subtle transition-transform duration-150 ease-out ${open ? 'rotate-180' : ''}`} data-id="element-359" data-mp="2m03p7hvui8dn" />
              </button>
              {open && <div className="overflow-x-auto border-t border-line" data-id="element-360" data-mp="28143ahzpw7l6">
                  <table className="w-full min-w-[520px] text-left" data-id="element-361" data-mp="28370pn3792zx">
                    <thead data-id="element-362" data-mp="233u1e2v563gg">
                      <tr className="border-b border-line bg-canvas text-[12px] uppercase tracking-wide text-ink-subtle" data-id="element-363" data-mp="234nc1ex81d3v">
                        <th scope="col" className="px-5 py-2 font-semibold" data-id="element-364" data-mp="1b5xrsel5e05">
                          Course
                        </th>
                        <th scope="col" className="px-5 py-2 font-semibold" data-id="element-365" data-mp="1vqcrdw9ji091">
                          Title
                        </th>
                        <th scope="col" className="px-5 py-2 text-right font-semibold" data-id="element-366" data-mp="20jo0y55qkv4n">
                          Units
                        </th>
                        <th scope="col" className="px-5 py-2 text-right font-semibold" data-id="element-367" data-mp="1qt31kfi8nmko">
                          Score
                        </th>
                        <th scope="col" className="px-5 py-2 text-right font-semibold" data-id="element-368" data-mp="2eft4dj2evl6c">
                          Grade
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-line" data-id="element-369" data-mp="25jafchxawhf1">
                      {semester.grades.map(grade => <tr key={grade.courseCode} data-id="element-370" data-mp="u20wnxlzxtes">
                          <td className="cz-num px-5 py-3 text-[13px] font-medium text-ink" data-id="element-371" data-mp="u0hbptpeau6o">
                            {grade.courseCode}
                          </td>
                          <td className="px-5 py-3 text-[13px] text-ink-muted" data-id="element-372" data-mp="qitoydj86o50">{grade.title}</td>
                          <td className="cz-num px-5 py-3 text-right text-[13px] text-ink-muted" data-id="element-373" data-mp="ljqiconlk9ux">
                            {grade.units}
                          </td>
                          <td className="cz-num px-5 py-3 text-right text-[13px] text-ink-muted" data-id="element-374" data-mp="vj7mh1n7afos">
                            {grade.score}
                          </td>
                          <td className="px-5 py-3 text-right text-[13px] font-semibold text-ink" data-id="element-375" data-mp="7r9a0ec0mea2">
                            {grade.grade}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>}
            </Panel>;
      })}
      </div>

      <div className="space-y-6" data-id="element-376" data-mp="3l6yu4rb4tf65">
        <Panel title="Cumulative" data-id="element-377" data-mp="3l65hxatelxgm">
          <p className="cz-num text-3xl font-semibold tracking-tight text-ink" data-id="element-378" data-mp="3g9oxaqley18a">
            {cgpa.toFixed(2)}
          </p>
          <p className="mt-1 text-[13px] text-ink-muted" data-id="element-379" data-mp="2jitkoavfyutz">CGPA out of 5.00 · Second Class Upper</p>
          <ul className="mt-4 space-y-2 border-t border-line pt-4 text-[13px]" data-id="element-380" data-mp="2nkeypzjppf5r">
            {results.map(semester => <li key={semester.id} className="flex justify-between" data-id="element-381" data-mp="2sh5fkp3cces8">
                <span className="text-ink-muted" data-id="element-382" data-mp="2xa8b32rohyb2">{semester.label}</span>
                <span className="cz-num font-medium text-ink" data-id="element-383" data-mp="328jjra68m2rp">{semester.gpa.toFixed(2)}</span>
              </li>)}
          </ul>
        </Panel>
        <Panel title="Academic documents" data-id="element-384" data-mp="375jif00rc38s">
          <ul className="space-y-2.5 text-[13px]" data-id="element-385" data-mp="3b97rxo8y98wo">
            {['Statement of result', 'Course registration slip', 'Transcript request'].map(document => <li key={document} className="flex items-center justify-between gap-3" data-id="element-386" data-mp="3g5olwz2tyhho">
                  <span className="text-ink" data-id="element-387" data-mp="1gx1aw8tdjxwg">{document}</span>
                  <span className="text-[12px] text-ink-subtle" data-id="element-388" data-mp="1lut559hhrw3t">
                    Requires university integration
                  </span>
                </li>)}
          </ul>
        </Panel>
      </div>
    </div>;
}